<div class="flex flex-col gap-4 w-1/2 ">
  <activar-card>
    @if (!addPaymentMode()) {
      <app-payments-list [paymentMethods]="paymentMethods()" [loading]="paymentMethodsLoading()" />
      <activar-button
        color="default"
        class="mb-5"
        fill="clear"
        expand="block"
        text="+ Agregar"
        (click)="addPaymentMode.set(true)" />
    } @else {
      <div class="mt-30 text-left">
        @if (paymentMethods().length > 0) {
          <activar-back-button
            text="Volver"
            (click)="addPaymentMode.set(false)" />
        }
        <h3 class="mt-2 text-left">Agregar medio de pago</h3>
        <app-add-payment
          class="payment-options-left"
          [paymentGateways]="paymentGateways()"
          [needSecurityCode]="false"
          [loading]="loading()"
          (EventPaymentSubmit)="setPayment($event)"
        />
      
      </div>
    }
  </activar-card>
  
</div>
